/** Путь без query и hash: '/news?page=2#top' → '/news'. */
export const getPathname = (url?: string): string => (url ?? '').split(/[?#]/)[0] || '/'

/**
 * Принадлежит ли URL одному из префиксов разделов нового фронта.
 * Совпадение посегментное, по аналогии с pathType Prefix у ingress
 */
export const isNuxt4Route = (url: string, prefixes: ReadonlyArray<string>): boolean => {
  const path = getPathname(url)
  return prefixes.some(prefix => path === prefix || path.startsWith(`${prefix}/`))
}
